import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

interface Response {
  flagged_employees_count?: number;
}
const QUERY_KEY = 'UNDELIVERABLE_MAIL_BRIEF_QUERY';
const useUndeliverableMailBriefQuery = () => {
  const { data, isLoading } = useQuery(
    [QUERY_KEY],
    () => api.get<Response>(API_URL.REPORTS_UNDELIVERABLE_ADDRESS_REPORT_BRIEF),
    {
      cacheTime: 0,
    }
  );

  const formattedData = useMemo(() => {
    const response = data?.data;
    const count = response?.flagged_employees_count;
    return count != null ? count : null;
  }, [data?.data]);

  return {
    isLoading,
    data: formattedData,
  };
};

export default useUndeliverableMailBriefQuery;
